<template>
  <MarkedMapModalPreview
    :points="[destinationPosition]"
    :see-full-map-button-position="seeFullMapButtonPosition"
  />
</template>

<script setup>
const props = defineProps({
  destination: {
    type: Object,
    required: true,
  },

  seeFullMapButtonPosition: {
    type: String,
    default: 'bottom',
  },
})

const destinationPosition = computed(() => {
  const { longitude, latitude } = props.destination
  return [longitude, latitude]
})
</script>
